import { isOpen, type Task } from './model.ts';

/** The pure half of "seen" (tasks/seen.ts has the hook and the rule's words). */

/** The tasks drawn on a screen that are the viewer's own and not yet seen by them. */
export function toMarkSeen(shown: readonly Pick<Task, 'id' | 'assigned_to' | 'status' | 'times'>[], viewerId: string | null | undefined): string[] {
  if (!viewerId) return [];
  const ids: string[] = [];
  for (const t of shown) {
    if (t.assigned_to?.id === viewerId && t.times.seen_at === null && isOpen(t) && !ids.includes(t.id)) ids.push(t.id);
  }
  return ids;
}

/** At most 500 ids a call (the contract's limit). */
export function batches(ids: readonly string[], size = 500): string[][] {
  const out: string[][] = [];
  for (let i = 0; i < ids.length; i += size) out.push(ids.slice(i, i + size));
  return out;
}

/** One holding of one task: the task and when it was given to its current holder. */
export const assignmentKey = (t: Pick<Task, 'id' | 'times'>) => `${t.id}@${t.times.assigned_at ?? ''}`;

/** The ids to report now, and their holding keys: the viewer's own unseen rows not already asked for this holding. */
export function pendingSeen(shown: readonly Pick<Task, 'id' | 'assigned_to' | 'status' | 'times'>[], viewerId: string | null | undefined,
  already: ReadonlySet<string>): { ids: string[]; keys: string[] } {
  const byId = new Map(shown.map((t) => [t.id, assignmentKey(t)]));
  const ids = toMarkSeen(shown, viewerId).filter((id) => !already.has(byId.get(id)!));
  return { ids, keys: ids.map((id) => byId.get(id)!) };
}

